var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00134 0.0922151C4.83504 0.0918899 4.67388 0.149807 4.54583 0.255913L0.275426 3.81458C0.130078 3.93539 0.0386741 4.10899 0.0213223 4.29719C0.00397037 4.4854 0.0620919 4.67278 0.182901 4.81813C0.303709 4.96348 0.477309 5.05488 0.665511 5.07223C0.853712 5.08959 1.0411 5.03146 1.18645 4.91066L5.00134 1.72209L8.81624 4.79678C8.88904 4.8559 8.97281 4.90005 9.06273 4.92669C9.15265 4.95333 9.24694 4.96194 9.3402 4.95202C9.43346 4.9421 9.52384 4.91384 9.60614 4.86888C9.68844 4.82392 9.76105 4.76313 9.81978 4.69002C9.88496 4.61684 9.93433 4.53098 9.96478 4.43783C9.99524 4.34469 10.0061 4.24625 9.99678 4.1487C9.98742 4.05115 9.95802 3.95658 9.91042 3.87092C9.86282 3.78526 9.79804 3.71035 9.72014 3.65089L5.44973 0.21321C5.318 0.123876 5.16013 0.081275 5.00134 0.0922151Z",
    fill: "#676C77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.a3a68fd6185c41e131e02e6a0a633ba4.svg";
export { ForwardRef as ReactComponent };